import React, { useEffect, useRef, useContext } from 'react';
import { GradeContext } from 'context/Context';

const Video = () => {
    const { loId } = useContext(GradeContext);
    const videoRef = useRef();

    useEffect(() => {
        console.log('🎥 Video component mounted with loId:', loId);
        if (videoRef.current) {
            // Ensure it plays with sound (muted false)
            videoRef.current.muted = false;
            videoRef.current.play().catch((err) => {
                console.warn('Autoplay failed:', err);
            });
        }
    }, [loId]);

    if (!loId) return null;

    const videoUrl = `https://www.eduhax.com/Videos/${loId}.mp4`;

    return (
        <div className="mt-4 d-flex justify-content-center">
            <video
                ref={videoRef}
                src={videoUrl}
                width="60%"
                controls
                autoPlay
                muted={false}
                style={{
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    display: 'block'
                }}
            >
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default Video;
